import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Home } from "lucide-react";
import { Link } from "react-router-dom";
gsap.registerPlugin(ScrollTrigger);
const Hero = () => {
  const component = useRef(null);
  const textRef = useRef(null);
  const ctaRef = useRef(null);
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animated text entry
      gsap.from(textRef.current, {
        y: 100,
        opacity: 0,
        duration: 1.2,
        ease: "power4.out",
        delay: 0.2
      });

      // CTA button animation
      gsap.from(ctaRef.current, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        delay: 0.8
      });

      // Floating animation for the astronaut
      gsap.to(".astronaut-float", {
        y: 15,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });

      // Scroll-triggered text animations
      gsap.utils.toArray<HTMLElement>(".scroll-reveal").forEach((el, index) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          },
          y: 50,
          opacity: 0,
          duration: 1,
          delay: index * 0.3,
          ease: "power3.out"
        });
      });
    }, component);
    return () => ctx.revert();
  }, []);
  return <div ref={component} className="relative min-h-screen bg-[#F8FAFF] overflow-hidden">
      {/* Main Content */}
      <div className="pt-20 md:pt-32 px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto grid gap-8 md:gap-16 items-center">
          <div className="space-y-6 md:space-y-8 col-span-2 flex flex-col items-center">
            <div ref={textRef} className="space-y-4 md:space-y-6 text-center flex flex-col items-center">
              <img src="/lovable-uploads/8d009ca5-341e-4ca2-b7d0-2754400a0b95.png" alt="Astronaut" className="w-32 md:w-48 h-auto mb-4 md:mb-8 astronaut-float" />
              <h1 className="text-4xl md:text-6xl lg:text-8xl font-light leading-none">
                <span className="block font-normal">Vertigo AI</span>
              </h1>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3">
                <p className="text-lg md:text-xl lg:text-2xl font-light text-gray-600">HR-tech startup</p>
                <span className="bg-gray-200 text-gray-800 px-3 md:px-4 py-1 md:py-2 rounded-full text-xs md:text-sm font-medium">Italy</span>
              </div>
              <p className="text-base md:text-lg lg:text-2xl text-gray-800 font-medium max-w-3xl mt-2 md:mt-4 px-4 md:px-0">La piattaforma AI per aiutare le aziende a creare processi di assunzione automatizzati, equi, e basati sulle competenze.</p>
              <div ref={ctaRef} className="inline-block">
                {/* Empty div to maintain spacing - removed the badge from here */}
              </div>
            </div>
          </div>

          <div className="relative space-y-6 md:space-y-10 mt-8 md:mt-12 px-4 md:px-0 col-span-2 w-full">
            <div className="flex flex-col items-center gap-4 md:gap-8 md:flex-row md:items-center">
              <div className="w-16 md:w-[100px] flex justify-center flex-shrink-0">
                <img src="/lovable-uploads/5d3658a9-c1a5-4bb2-aff8-b7093836deb6.png" alt="Lightbulb" className="w-10 md:w-12 lg:w-20 h-auto object-fill" />
              </div>
              <p className="scroll-reveal text-base md:text-xl lg:text-2xl font-light text-gray-700 text-center md:text-left px-2 md:px-0">
                Lascia che i nostri agenti AI si occupino di analizzare, colloquiare, e produrre feedback costruttivi per i candidati. Crea processi inclusivi e skill-based.
                <Link to="/use-cases" className="ml-3 inline-flex items-center px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-full transition-colors duration-200">
                  Scopri di più
                </Link>
              </p>
            </div>
            
            
            
            <div className="flex flex-col items-center gap-4 md:gap-8 md:flex-row md:items-center">
              <div className="w-16 md:w-[100px] flex justify-center flex-shrink-0">
                
              </div>
              
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 md:gap-6 z-50 bg-white/80 backdrop-blur-sm px-3 py-3 md:px-6 md:py-3 rounded-full shadow-md">
        <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-black/80 text-white">
          <Home size={14} className="md:w-4 md:h-4" />
        </div>
        <Link to="/team" className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <span className="text-xs font-medium">Team</span>
        </Link>
        <Link to="/use-cases" className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <span className="text-xs font-medium">Cosa facciamo</span>
        </Link>
        
      </div>
    </div>;
};
export default Hero;